"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @returns {boolean} true if monitoring is activated
 */
function isMonitoringActivated() {
    try {
        return typeof newrelic === 'object';
    }
    catch (e) {
        return false;
    }
}
exports.isMonitoringActivated = isMonitoringActivated;
/**
 * Send error to monitoring
 *
 * @param {Error} error to send
 */
function monitorError(error) {
    if (isMonitoringActivated()) {
        monitorErrorWrapper(error);
    }
}
exports.monitorError = monitorError;
/**
 * Encapsulates NewRelic call
 * @param {{}} error to send
 */
function monitorErrorWrapper(error) {
    try {
        newrelic.noticeError(error);
    }
    catch (e) {
        // Initial error that failed to be sent to newrelic
        console.error(error);
        // New error raised while calling newrelic api
        console.error(e);
    }
}
/**
 * Monitor a page action
 * @param {string} name page action name
 * @param {{[p: string]: string}} attribute page action attributes
 */
function monitorPageAction(name, attributes) {
    if (isMonitoringActivated()) {
        try {
            var tempAttributes = attributes ? attributes : {};
            newrelic.addPageAction(name, tempAttributes);
        }
        catch (e) {
            console.error(e);
        }
    }
}
exports.monitorPageAction = monitorPageAction;
/**
 * Creates a new interaction tracer allowing to trace elapsed time:
 * - start time: call of this function
 * - end time: call of callback function returned by this function
 *
 * Precondition: a NewRelic browser interaction must be ongoing and
 * saved in order for this tracer to be monitored by NewRelic.
 *
 * In the context of workbook-templates-widgets, we rely on this
 * interaction being created and saved by the parent C# container.
 *
 * @param {string} name Name of the interaction tracer
 * @returns {() => void} Function to call by caller to end tracer
 */
function monitorInteractionTracer(name) {
    if (isMonitoringActivated()) {
        try {
            return newrelic.interaction().createTracer(name);
        }
        catch (e) {
            console.error(e);
        }
    }
    // If we get here, return empty function w/o effect
    return function () {
        return undefined;
    };
}
exports.monitorInteractionTracer = monitorInteractionTracer;
/**
 * Add an attribute to an ongoing NewRelic browser interaction.
 *
 * Precondition: a NewRelic browser interaction must be ongoing and
 * saved in order for this attribute to be saved by NewRelic.
 *
 * In the context of workbook-templates-widgets, we rely on this
 * interaction being created and saved by the parent C# container.
 *
 * @param {string} name Name/Key of the attribute
 * @param {{}} value Value of the attribute
 */
function monitorInteractionAttribute(name, value) {
    if (isMonitoringActivated()) {
        try {
            newrelic.interaction().setAttribute(name, value);
        }
        catch (e) {
            console.error(e);
        }
    }
}
exports.monitorInteractionAttribute = monitorInteractionAttribute;
//# sourceMappingURL=Monitoring.js.map